/**
 * LeaderboardPagination - Reusable pagination component for leaderboards
 * Supports First, Previous, Next, Last navigation
 */
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react'

const LeaderboardPagination = ({
  currentPage,
  totalItems,
  pageSize,
  onPageChange,
  hasMore,
  className = ''
}) => {
  const totalPages = Math.ceil(totalItems / pageSize)
  const isFirstPage = currentPage === 0
  const isLastPage = !hasMore && currentPage >= totalPages - 1

  const startItem = currentPage * pageSize + 1
  const endItem = Math.min((currentPage + 1) * pageSize, totalItems)

  return (
    <div
      className={`flex items-center justify-between px-6 py-4 border-t border-gray-200 dark:border-gray-700 ${className}`}
    >
      <span className="text-sm text-gray-600 dark:text-gray-400">
        Showing {startItem.toLocaleString()} - {endItem.toLocaleString()}
        {totalItems > 0 && (
          <span className="text-gray-400 dark:text-gray-500">
            {' '}
            of {totalItems.toLocaleString()}
          </span>
        )}
      </span>
      <div className="flex gap-1">
        {/* First Page */}
        <button
          onClick={() => onPageChange(0)}
          disabled={isFirstPage}
          className="btn-secondary p-2 disabled:opacity-50 disabled:cursor-not-allowed"
          title="First page"
        >
          <ChevronsLeft className="w-4 h-4" />
        </button>

        {/* Previous Page */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={isFirstPage}
          className="btn-secondary p-2 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Previous page"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>

        {/* Page Indicator */}
        <span className="flex items-center px-3 text-sm text-gray-600 dark:text-gray-400">
          Page {currentPage + 1}
          {totalPages > 0 && ` of ${totalPages}`}
        </span>

        {/* Next Page */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={isLastPage}
          className="btn-secondary p-2 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Next page"
        >
          <ChevronRight className="w-4 h-4" />
        </button>

        {/* Last Page */}
        <button
          onClick={() => onPageChange(totalPages - 1)}
          disabled={isLastPage}
          className="btn-secondary p-2 disabled:opacity-50 disabled:cursor-not-allowed"
          title="Last page"
        >
          <ChevronsRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}

export default LeaderboardPagination
